import React, { Component } from 'react';
import { Typography, Divider, Box, Grid, Button, Paper, Stack, Checkbox, FormControlLabel, } from '@mui/material';
import SimpleAutoComplete from "../../../components/auto-complete/autocomplete";
import SimpleDatePicker from '../../../components/date-pickers/inline-no-today';
import {

} from '@mui/material';
class DataSendingConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }



  render() {
    return (
      <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
        <Grid item sx={12} sm={12} md={8}>
          <Paper style={{ padding: '20px' }}>
            <Typography variant="h3" gutterBottom style={{ fontWeight: 'bold' }}>
              Confirmação de compartilhamento de dados e permissão para contato.
            </Typography>
            <Divider />
            <Typography variant="body1" paragraph mt={2}>
              Para facilitar seu acesso e o gerenciamento das suas informações,
              este portal utiliza o login via Gov.br.
            </Typography>

            <Typography variant="body1" paragraph>
              Ao fazer login, você terá um acesso mais rápido e seguro aos seus
              dados e serviços, sem complicações. Caso prossiga, os seguintes
              dados do seu cadastro no Gov.br serão compartilhados com este
              Portal de Atendimento:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">Nome</Typography>
              </li>
              <li>
                <Typography variant="body1">E-mail</Typography>
              </li>
              <li>
                <Typography variant="body1">CPF</Typography>
              </li>
              <li>
                <Typography variant="body1">Telefone</Typography>
              </li>
            </ul>
            <Divider />
            {/*this.props.sendConfirmationScreen &&

              <div>

                <Typography variant="body1" paragraph mt={2}>
                  Além disso, gostaríamos da sua autorização para que a Central de
                  Atendimento possa entrar em contato com você, quando necessário,
                  para oferecer suporte ao seu atendimento ou solicitar feedback.
                  Esse contato será feito de forma segura pelos nossos canais de
                  suporte.
                </Typography>
                <Typography variant="body1" paragraph>
                  Deseja continuar e autorizar o compartilhamento dos seus dados e o
                  contato pela Central de Atendimento?
                </Typography>

                <Grid container justifyContent="center" spacing={2} style={{ marginTop: '10px' }}>



                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={this.props.handlePreviousScreen}
                    // color="secondary"
                    // onClick={this.handleCancel}
                    // style={{ backgroundColor: 'red', color: 'white' }}
                    >
                      Voltar
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.props.handleOptInConfirmation}
                    // onClick={this.handleConfirm}
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </Grid>
              </div>
            */}



            <div>

              <Typography variant="body1" paragraph mt={2}>
                Para avançar você deve complementar suas informações com os campos abaixo
              </Typography>

              <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                    <SimpleAutoComplete
                      label={this.props.intl.formatMessage({ id: "contact.preference" })}
                      name="contactPreferenceId"
                      options={this.props.contactPreferenceList ? this.props.contactPreferenceList : []}
                      stateName="contactPreferenceId"
                      changeSelect={this.props.changeValues}
                      selected={this.props.contactPreferenceId}
                    />
                  </Grid> */}


                <Grid item xs={12} >
                  <SimpleAutoComplete
                    label={this.props.intl.formatMessage({ id: "unit" })}
                    name="unit"
                    options={this.props.unitList ? this.props.unitList : []}
                    stateName="unitId"
                    changeSelect={this.props.changeValues}
                    selected={this.props.unitId}
                  // required={props.isUnityObrigatory}
                  />
                </Grid>

                <Grid item sm={12} >
                  <SimpleAutoComplete
                    label={`Localidade (estado)`}
                    name="state"
                    options={this.props.statesList ? this.props.statesList : []}
                    stateName="state"
                    changeSelect={this.props.changeValues}
                    selected={this.props.state} />
                </Grid>
                <Grid item sm={12} ml={0.5} style={{ paddingBottom: '0px' }}>
                  <FormControlLabel
                    sx={{ mb: 0 }}
                    control={
                      <Checkbox
                        checked={this.props.authorizeSharingData}
                        onChange={this.props.handleCheckboxChange}
                        name="authorizeSharingData"
                        color="primary"
                      />
                    }
                    label="Autorizo o compartilhamento dos meus dados."
                  />

                </Grid>
                <Grid item sm={12} ml={0.5} mt={0} style={{ paddingBottom: '0px', paddingTop: '5px' }}>
                  <FormControlLabel
                    sx={{ mt: 0 }}

                    control={
                      <Checkbox
                        checked={this.props.allowContactBySupportCenter}
                        onChange={this.props.handleCheckboxChange}
                        name="allowContactBySupportCenter"
                        color="primary"
                      />
                    }
                    label="Autorizo ser contatado pela Central de Atendimento."
                  />

                </Grid>


                {/* 
                  <Grid item xs={12}>
                    <SimpleDatePicker
                      label={this.props.intl.formatMessage({ id: "date.of.birth" })}
                      name='dateOfBirth'
                      stateName='dateOfBirth'
                      changeDate={this.props.changeValues}
                      currentDate={this.props.dateOfBirth}
                    />
                  </Grid> */}

              </Grid>

              {this.props.disableConfirmButton == false &&

                <Grid container justifyContent="center" spacing={2} style={{ marginTop: '10px' }}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={this.props.handleOptInDenied}
                    // color="secondary"
                    // onClick={this.handleCancel}
                    // style={{ backgroundColor: 'red', color: 'white' }}
                    >
                      Cancelar
                    </Button>
                  </Grid>

                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.props.handleOptInConfirmation}
                      
                    // onClick={this.handleConfirm}
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </Grid>


              }

            </div>


          </Paper>
        </Grid>
      </Grid>
    );
  }
}

export default DataSendingConfirmation;
